import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { AnwendungsSelectorComponent } from '../../../components/anwendungs-selector/anwendungs-selector.component';
import {
    ArticleScanAutocompleteComponent,
    ArticleScanSelectedEvent,
} from '../../../components/article-scan-autocomplete/article-scan-autocomplete.component';
import { DiagnoseSelectorComponent } from '../../../components/diagnose-selector/diagnose-selector/diagnose-selector.component';
import { EntityViewerService } from '../../../components/entity-viewer/entity-viewer.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { ArtikelTierart, ArtikelTierartEvent } from '../../../components/tierart-selector/artikel-tierart';
import { TierartSelectorComponent } from '../../../components/tierart-selector/tierart-selector.component';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { SaveForAllDialogComponent } from '../../../dialogs/save-for-all-dialog/save-for-all-dialog.component';
import { Anwendung, AnwendungEvent } from '../../../documents/behandlungsanfrage/anwendung';
import { Indikation, IndikationEvent } from '../artikel-indikation/indikation';
import { ArtikelStueckliste, Material } from '../material';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';

@Component({
    selector: 'kiene-stueckliste',
    templateUrl: './stueckliste.component.html',
    styleUrls: ['./stueckliste.component.css'],
})
export class StuecklisteComponent implements OnInit {
    protected readonly KieneUtils = KieneUtils;

    @ViewChild('articleAutocomplete')
    articleAutocomplete: ArticleScanAutocompleteComponent;
    @ViewChild('behandlungSelector') behandlungSelector: MatSelect;
    @ViewChild('tierartSelector') tierartSelector: TierartSelectorComponent;
    @ViewChild('anwendungSelector')
    anwendungSelector: AnwendungsSelectorComponent;
    @ViewChild('diagnoseSelector') diagnoseSelector: DiagnoseSelectorComponent;

    @Input('material') material: Material;
    @Input('hideTierartAnwendungDiagnoseDosierung') hideTierartAnwendungDiagnoseDosierung = false;
    // Optional: Rabatt-Spalte ausblenden (z.B. im Behandlungsartikel-Dialog)
    @Input('hideRabatt') hideRabatt = false;
    @Output('reload') reload = new EventEmitter<number>();
    // availableMandanten: Mandant[] = [];

    artikelliste: ArtikelStueckliste[] = [];
    currentPosition: ArtikelStueckliste;
    selectedMaterial: Material;
    selectedArtikelTierart: ArtikelTierart;
    selectedAnwendung: Anwendung;
    selectedDiagnose: Indikation;

    einkaufspreis = 0;

    anwendungsdauerCtrl = new UntypedFormControl();
    mengeCtrl = new UntypedFormControl();
    dosierungCtrl = new UntypedFormControl();
    behandlungJaNeinCtrl = new UntypedFormControl();

    constructor(
        private readonly api: KieneTableService,
        private readonly notification: MessageService,
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly localStorageService: LocalStorageService,
        private readonly entityViewerService: EntityViewerService,
    ) {}

    ngOnInit(): void {
        this.loadArtikeliste();
    }

    loadArtikeliste() {
        // Wenn noch kein Material oder keine Artikel-ID vorhanden ist (z.B. Artikel noch nicht gespeichert),
        // kann keine Stückliste geladen werden.
        if (!this.material || !this.material.artikel_id) {
            this.artikelliste = [];
            this.einkaufspreis = 0;
            this.entityViewerService.setEntity(this.artikelliste);
            return;
        }

        const params = new HttpParams().append('artikel_id_liste', this.material.artikel_id.toString());
        this.api.get(this.apiBaseUrl + 'artikel_stueckliste/read.php', params).subscribe(
            response => {
                this.artikelliste = response.records;
                this.entityViewerService.setEntity(this.artikelliste);
                this.berechneEinkaufspreis();
                this.reload.emit(this.material.artikel_id);
            },
            error => {
                // Fehler beim Laden der Stückliste nicht stillschweigend ignorieren,
                // sondern eine Meldung anzeigen.
                this.notification.errorMessage('Stückliste konnte nicht geladen werden!', error);
                this.artikelliste = [];
                this.einkaufspreis = 0;
                this.entityViewerService.setEntity(this.artikelliste);
            },
        );
    }

    berechneEinkaufspreis() {
        this.einkaufspreis = 0;
        for (const as of this.artikelliste) {
            this.einkaufspreis += as.einzelpreis * as.artikelmenge * (1 - as.rabatt / 100);
        }
    }

    setSelectedMaterial(asse: ArticleScanSelectedEvent) {
        this.selectedMaterial = asse.article;
        if (!this.selectedMaterial) {
            return;
        }
        this.tierartSelector.ladeTierartenFuerMaterialUndKunde(
            'stueckliste.component.ts setSelectedMaterial',
            this.selectedMaterial.artikel_id,
            true,
            false,
        );
    }

    setSelectedTierart(event: ArtikelTierartEvent) {
        this.selectedArtikelTierart = event.artikelTierart;
        if (!this.selectedArtikelTierart) {
            return;
        }
        this.anwendungsdauerCtrl.setValue(this.selectedArtikelTierart.behandlung_tage);
        this.dosierungCtrl.setValue(this.selectedArtikelTierart.menge);
        this.anwendungSelector.loadAnwendungen(
            this.selectedArtikelTierart.artikel_id,
            this.selectedArtikelTierart.tierart_id,
            true,
            false,
        );
    }

    setAnwendung(anwendungEvent: AnwendungEvent) {
        this.selectedAnwendung = anwendungEvent.anwendung;
        if (!this.selectedAnwendung) {
            return;
        }
        this.diagnoseSelector.loadDiagnosen(
            this.selectedAnwendung.artikel_id,
            this.selectedArtikelTierart.tierart_id,
            this.selectedAnwendung.anwendung_id,
            true,
            false,
        );
    }

    setDiagnose(event: IndikationEvent) {
        this.selectedDiagnose = event.indikation;
    }

    clear() {
        this.currentPosition = null;
        this.articleAutocomplete.clear();
        this.tierartSelector.clear();
        this.anwendungSelector.clear();
        this.diagnoseSelector.clear();
        this.anwendungsdauerCtrl.setValue(null, { emitEvent: false });
        this.dosierungCtrl.setValue(null, { emitEvent: false });
        this.mengeCtrl.setValue(null, { emitEvent: false });
        this.behandlungJaNeinCtrl.setValue(null, { emitEvent: false });
        this.articleAutocomplete.setFocus();
    }

    addPosition() {
        if (!this.currentPosition) {
            this.currentPosition = new ArtikelStueckliste();
            // Initialisiere alle Felder mit Standardwerten, um undefined zu vermeiden
            this.currentPosition.dosierung = 0;
            this.currentPosition.anwendungsdauer = 0;
            this.currentPosition.wartezeit = 0;
            this.currentPosition.behandlung = 0;
            this.currentPosition.artikelmenge = 0;
            this.currentPosition.rabatt = 0;
            this.currentPosition.tierart_id = null;
            this.currentPosition.anwendung_id = null;
            this.currentPosition.indikation_id = null;
        }
        this.currentPosition.artikel_id_liste = this.material.artikel_id;
        this.currentPosition.artikel_id_pos = this.selectedMaterial.artikel_id;
        
        if (this.hideTierartAnwendungDiagnoseDosierung) {
            // Für Behandlungsartikel-Stücklisten: Felder mit null setzen (Foreign Key Constraints benötigen null statt 0)
            this.currentPosition.dosierung = 0;
            this.currentPosition.tierart_id = null;
            this.currentPosition.anwendung_id = null;
            this.currentPosition.indikation_id = null;
            this.currentPosition.wartezeit = 0;
            this.currentPosition.behandlung = 0;
            this.currentPosition.anwendungsdauer = 0;
        } else {
            this.currentPosition.dosierung = this.dosierungCtrl.value || 0; // trotz mengenartikel
            this.currentPosition.anwendungsdauer = this.anwendungsdauerCtrl.value || 0;
            if (KieneUtils.isApiZero(this.selectedMaterial.mengenartikel)) {
                this.currentPosition.tierart_id = this.selectedArtikelTierart?.tierart_id || null;
                this.currentPosition.anwendung_id = this.selectedAnwendung?.anwendung_id || null;
                this.currentPosition.indikation_id = this.selectedDiagnose?.indikation_id || null;
                this.currentPosition.wartezeit = this.selectedAnwendung?.wartezeit_fleisch || 0;
                this.currentPosition.behandlung = this.behandlungJaNeinCtrl.value || 0;
            } else {
                // Auch bei mengenartikel die Felder auf null setzen, damit sie nicht undefined sind
                this.currentPosition.tierart_id = null;
                this.currentPosition.anwendung_id = null;
                this.currentPosition.indikation_id = null;
                this.currentPosition.wartezeit = 0;
                this.currentPosition.behandlung = 0;
            }
        }
        this.currentPosition.artikelmenge = this.mengeCtrl.value || 0;

        // Stückliste-Positionen werden immer nur für den aktuellen Mandanten gespeichert
        // Kein Dialog für mehrere Mandanten - die Stückliste ist mandantenspezifisch
            this.createOrUpdateArtikelStueckliste(this.currentPosition);
    }

    removePosition(as: ArtikelStueckliste) {
        const confirmDialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: {
                title: 'Wirklich löschen?',
                text: 'Wollen Sie die Position ' + as.artikel_pos + ' wirklich löschen?',
            },
        });

        confirmDialogRef.afterClosed().subscribe(resultConfirm => {
            if (resultConfirm) {
                if (this.localStorageService.currentUserHasPermission(4405)) {
                    const params = new HttpParams().append('as_id', as.as_id.toString());
                    this.api
                        .get(this.apiBaseUrl + 'artikel_stueckliste/read_mandanten_delete.php', params)
                        .subscribe(responseMandanten => {
                            const availableMandanten: Mandant[] = responseMandanten.records;

                            if (availableMandanten.length > 1) {
                                const dialogRef = this.dialog.open(SaveForAllDialogComponent, {
                                    data: { availableMandanten: availableMandanten, buttonText: 'Löschen' },
                                });

                                dialogRef.afterClosed().subscribe(result => {
                                    if (result) {
                                        // result ist ein Objekt mit mandanten_ids, preise, bezeichnungen
                                        // Für das Löschen benötigen wir nur die mandanten_ids als Array
                                        // Wenn result ein Array ist (Fallback), verwende es direkt
                                        // Ansonsten extrahiere mandanten_ids aus dem Objekt
                                        if (Array.isArray(result)) {
                                        as.mandanten_ids = result;
                                        } else if (result.mandanten_ids && Array.isArray(result.mandanten_ids)) {
                                            as.mandanten_ids = result.mandanten_ids;
                                        } else {
                                            // Fallback: Wenn kein Array gefunden, verwende leeres Array
                                            as.mandanten_ids = [];
                                        }
                                        this.removeArtikelStueckliste(as);
                                    }
                                });
                            } else {
                                this.removeArtikelStueckliste(as);
                            }
                        });
                } else {
                    this.removeArtikelStueckliste(as);
                }
            }
        });
    }

    editPosition(as: ArtikelStueckliste) {
        this.currentPosition = as;
        this.loadCurrentPositionForEditing();
    }

    loadCurrentPositionForEditing() {
        const m = new Material();
        m.artikel_id = this.currentPosition.artikel_id_pos;
        m.artikel_me = this.currentPosition.artikel_pos;
        m.bezeichnung = this.currentPosition.artikel_pos;
        m.abgabe = this.currentPosition.abgabe_artikel;
        m.behandlung = this.currentPosition.behandlung_artikel;
        m.mengenartikel = this.currentPosition.mengenartikel;

        this.selectedMaterial = m;

        this.articleAutocomplete.setMaterial(m, false);

        if (!this.hideTierartAnwendungDiagnoseDosierung) {
            const at = new ArtikelTierart();
            at.tierart_id = this.currentPosition.tierart_id;
            at.tierart = this.currentPosition.tierart;
            at.artikel_id = this.currentPosition.artikel_id_pos;
            at.artikel = this.currentPosition.artikel_pos;

            this.selectedArtikelTierart = at;

            if (this.tierartSelector) {
                this.tierartSelector.setTierart(at, false, false);
            }

            const a = new Anwendung();
            a.anwendung = this.currentPosition.anwendung;
            a.anwendung_id = this.currentPosition.anwendung_id;
            a.artikel_id = this.currentPosition.artikel_id_pos;
            a.artikel = this.currentPosition.artikel_pos;
            a.wartezeit_fleisch = this.currentPosition.wartezeit;

            this.selectedAnwendung = a;

            if (this.anwendungSelector) {
                this.anwendungSelector.setAnwendung(a, at.tierart_id, false, false);
            }

            const d = new Indikation();
            d.indikation_id = this.currentPosition.indikation_id;
            d.diagnose = this.currentPosition.diagnose;
            d.artikel_id = this.currentPosition.artikel_id_pos;
            d.tierart_id = this.currentPosition.tierart_id;

            this.selectedDiagnose = d;
            if (this.diagnoseSelector) {
                this.diagnoseSelector.setDiagnose(d, a.anwendung_id, false, false);
            }
            this.behandlungJaNeinCtrl.setValue(this.currentPosition.behandlung);
            this.dosierungCtrl.setValue(this.currentPosition.dosierung);
            this.anwendungsdauerCtrl.setValue(this.currentPosition.anwendungsdauer);
        } else {
            // Felder mit 0 setzen, wenn ausgeblendet
            this.behandlungJaNeinCtrl.setValue(0);
            this.dosierungCtrl.setValue(0);
            this.anwendungsdauerCtrl.setValue(0);
        }

        this.anwendungsdauerCtrl.setValue(this.currentPosition.anwendungsdauer);

        this.mengeCtrl.setValue(this.currentPosition.artikelmenge);

        this.articleAutocomplete.setFocus();
    }

    createOrUpdateArtikelStueckliste(as: ArtikelStueckliste) {
        // Bereinige das Objekt: Entferne undefined Werte und konvertiere sie zu null
        const cleanedData: any = {};
        Object.keys(as).forEach(key => {
            const value = (as as any)[key];
            if (value !== undefined) {
                cleanedData[key] = value;
            } else {
                // Setze undefined Felder auf null für Foreign Keys, sonst auf 0
                if (key === 'tierart_id' || key === 'anwendung_id' || key === 'indikation_id') {
                    cleanedData[key] = null;
                } else if (typeof (as as any)[key] === 'number') {
                    cleanedData[key] = 0;
                } else {
                    cleanedData[key] = null;
                }
            }
        });
        
        this.api.updateEntity(this.apiBaseUrl + 'artikel_stueckliste/update.php', cleanedData).subscribe(
            () => {
                this.notification.infoMessage('Die Position wurde erfolgreich gespeichert!');
                // Stückliste neu laden, damit der Einkaufspreis aktualisiert wird
                this.loadArtikeliste();
                this.clear();
            },
            error => {
                this.notification.errorMessage('Die Position konnte nicht gespeichert werden!', error);
            },
        );
    }

    removeArtikelStueckliste(a: ArtikelStueckliste) {
        // Stelle sicher, dass mandanten_ids ein Array ist (nicht undefined oder null)
        if (!a.mandanten_ids || !Array.isArray(a.mandanten_ids)) {
            a.mandanten_ids = [];
        }
        console.log('[STUECKLISTE DELETE] Sende Request:', { as_id: a.as_id, mandanten_ids: a.mandanten_ids });
        this.api.deleteEntity(this.apiBaseUrl + 'artikel_stueckliste/delete.php', a).subscribe(
            () => {
                this.loadArtikeliste();
            },
            error => {
                this.notification.errorMessage('Die Position konnte nicht entfernt werden!', error);
            },
        );
    }
}
